import React from "react";
import { Col, Form, Input, Modal, Row, Select, Spin, theme } from "antd";
import { SUCCESS_COLOR } from "../../constants/color";
import { PATCH, POST } from "../../frameworks/HttpClient";
import { URL_SETTING, URL_SKIM } from "../../constants/urls";
import useDropdownItem from "../../common/useDropdownItem";
import ErrorMessages from "../../common/ErrorMessages";
import CustomDatePicker from "../../common/CustomDatePicker";
import _ from "lodash";

export default function AddSkimChemicalStockModal(props) {

  const { open, onClose, target, onUpdate} = props;
  const [loading, setLoading] = React.useState(false);
  const [ errorMessages, setErrorMessages ] = React.useState(null);
  const [form] = Form.useForm();
  const isCreate = target === 'add'
  
  const [debouncedSupplier, setDebouncedSupplier] = React.useState('');
  const debounceSupplier = React.useCallback(_.debounce((_searchVal) => { setDebouncedSupplier(_searchVal) }, 800), []);
  const supplierChemicalDropdown = useDropdownItem({manual: true, url: URL_SETTING.SELLER_CHEMICAL, label: 'name', value:'id', pagination: true, params: { page_size: 999, name :  debouncedSupplier}})
  
  const [debouncedChemicalLot, setDebouncedChemicalLot] = React.useState('');
  const debounceChemicalLot = React.useCallback(_.debounce((_searchVal) => { setDebouncedChemicalLot(_searchVal) }, 800), []);
  const chemicalLotDropdown = useDropdownItem({manual: true, url: URL_SKIM.SKIM_CHEMICAL, label: 'name', value:'id', pagination: true, params: { page_size: 999, name: debouncedChemicalLot } })

  const handleOk = async() => {
    setLoading(true)
    setErrorMessages(null)
    try {
      const data = await form.validateFields()
      if(isCreate){
        await POST(URL_SKIM.SKIM_CHEMICAL_TRANSACTION, data)
      } else {
        await PATCH(`${URL_SKIM.SKIM_CHEMICAL_TRANSACTION}${target.id}/`, data)
      }
      onUpdate();
    } catch (error) {
      setErrorMessages(error.errorMessages)
    } finally {
      setLoading(false)
    }
  }

  const { token : { colorWarning, colorSuccess }} = theme.useToken();

  React.useEffect(() => {
    if(open){
      setErrorMessages(null)
      supplierChemicalDropdown.fetchOptions();
      chemicalLotDropdown.fetchOptions();
      if(isCreate){
        form.resetFields();
      } else {
        form.setFieldsValue(target)
        // chemicalLotDropdown.addOption({name : target.chemical_name, id: target.chemical, value : target.chemical});
        // supplierChemicalDropdown.addOption({name : target.supplier_name, id: target.supplier, value : target.supplier});
      }
    }
  },[open])

  React.useEffect(() => {
    if(open)
      chemicalLotDropdown.fetchOptions();
  },[debouncedChemicalLot])

  React.useEffect(() => {
    if(open)
      supplierChemicalDropdown.fetchOptions();
  },[debouncedSupplier])


	return(
    <Modal
      open={open}
      onCancel={onClose}
      okText={"ตกลง"}
      okButtonProps={{ style: { backgroundColor : isCreate ? SUCCESS_COLOR : colorWarning}, loading: loading }}
      cancelText={"ไม่"}
      cancelButtonProps={{ loading: loading }}
      title={isCreate ? "เพิ่มสต๊อกสารเคมีสกิม" : "แก้ไขสต๊อกสารเคมีสกิม"}
      width={600}
      onOk={handleOk}
    >
      <ErrorMessages message={errorMessages}/>
      <Form
        form={form}
        layout={'vertical'}
      >
        <Row>
          <Col span={12}>
            <CustomDatePicker
              label={'วันที่นำเข้า'} 
              name={"input_date"}
              rules={[{ required : true, message: 'กรุณากรอกข้อมูล' }]}
            />
          </Col>
          <Col span={12}>
            <Form.Item 
              label={'Lot No.'} 
              style={{ marginRight : 10}}
              name={"lot_no"}
              rules={[{ required : true, message: 'กรุณากรอกข้อมูล' }]}
            >
              <Input style={{ width : '100%' }} placeholder={'Lot No.'} autoComplete="off"/>
            </Form.Item>
          </Col>
          <Col span={16}>
            <Form.Item 
              label={'ชื่อสารเคมี'} 
              style={{marginRight : 10}}
              name={"chemical"}
              rules={[{ required : true, message: 'กรุณากรอกข้อมูล' }]}
            >
              <Select 
                showSearch
                style={{ width : '100%' }} 
                placeholder={'ชื่อสารเคมี'} 
                options={chemicalLotDropdown.options}
                filterOption={false}
                notFoundContent={chemicalLotDropdown.loading ? <Spin size="small" /> : "-"}
                onSearch={debounceChemicalLot}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item 
              label={'ปริมาณที่รับเข้า'} 
              style={{marginRight : 10}}
              name={'amount'}
              rules={[{ required : true, message: 'กรุณากรอกข้อมูล' }]}
            >
              <Input style={{ width : '100%' }} placeholder={'ปริมาณที่รับเข้า'} autoComplete="off"/>
            </Form.Item>
          </Col>
          <Col span={12}>
            <CustomDatePicker
              label={'วันที่หมดอายุ'} 
              name={'expire_date'}
              style={{ marginRight : 10}}
            />
          </Col>
          <Col span={12}>
            <Form.Item 
              label={'บริษัทผู้จำหน่าย'} 
              name={"supplier"}
              style={{ marginRight : 10}}
              rules={[{ required : true, message: 'กรุณากรอกข้อมูล' }]}
            >
              <Select 
                showSearch
                style={{ width : '100%' }} 
                placeholder={'บริษัทผู้จำหน่าย'} 
                options={supplierChemicalDropdown.options}
                filterOption={false}
                notFoundContent={supplierChemicalDropdown.loading ? <Spin size="small" /> : "-"}
                onSearch={debounceSupplier}
              />
            </Form.Item>
          </Col>
        
          <Col span={24}>
            <Form.Item 
              label={'หมายเหตุ'} 
              name={'note'}
              style={{ marginRight : 10}}
            >
              <Input.TextArea style={{ width : '100%' }} placeholder={'รายละเอียด'} autoComplete="off"/>
            </Form.Item>
          </Col>

        </Row>
      </Form>
    </Modal>
)
}